import { createAction } from "redux-actions";

export const STORE_USER_INFO = "STORE_USER_INFO";
export const storeUserInfo = createAction(STORE_USER_INFO);

export const CLEAR_USER_INFO = "CLEAR_USER_INFO";
export const clearUserInfo = createAction(CLEAR_USER_INFO);

export const CREATE_USER = "CREATE_USER";
export const createUser = createAction(CREATE_USER);

export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE";
export const createUserFailure = createAction(CREATE_USER_FAILURE);

export const CREATE_USER_REQUESTED = "CREATE_USER_REQUESTED";
export const createUserRequested = createAction(CREATE_USER_REQUESTED);

export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const createUserSuccess = createAction(CREATE_USER_SUCCESS);

export const LINKEDIN_LOGIN = "LINKEDIN_LOGIN";
export const linkedinLogin = createAction(LINKEDIN_LOGIN);

export const LINKEDIN_LOGIN_FAILURE = "LINKEDIN_LOGIN_FAILURE";
export const linkedinLoginFailure = createAction(LINKEDIN_LOGIN_FAILURE);

export const LINKEDIN_LOGIN_REQUESTED = "LINKEDIN_LOGIN_REQUESTED";
export const linkedinLoginRequested = createAction(LINKEDIN_LOGIN_REQUESTED);

export const LINKEDIN_LOGIN_SUCCESS = "LINKEDIN_LOGIN_SUCCESS";
export const linkedinLoginSuccess = createAction(LINKEDIN_LOGIN_SUCCESS);

export const LOGIN_USER = "LOGIN_USER";
export const loginUser = createAction(LOGIN_USER);

export const LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";
export const loginUserFailure = createAction(LOGIN_USER_FAILURE);

export const LOGIN_USER_REQUESTED = "LOGIN_USER_REQUESTED";
export const loginUserRequested = createAction(LOGIN_USER_REQUESTED);

export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const loginUserSuccess = createAction(LOGIN_USER_SUCCESS);

export const FETCH_USER_PROFILE = "FETCH_USER_PROFILE";
export const fetchUserProfile = createAction(FETCH_USER_PROFILE);

export const FETCH_USER_PROFILE_FAILURE = "FETCH_USER_PROFILE_FAILURE";
export const fetchUserProfileFailure = createAction(FETCH_USER_PROFILE_FAILURE);

export const FETCH_USER_PROFILE_REQUESTED = "FETCH_USER_PROFILE_REQUESTED";
export const fetchUserProfileRequested = createAction(FETCH_USER_PROFILE_REQUESTED);

export const FETCH_USER_PROFILE_SUCCESS = "FETCH_USER_PROFILE_SUCCESS";
export const fetchUserProfileSuccess = createAction(FETCH_USER_PROFILE_SUCCESS);

export const HANDLE_ONBOARDING = "HANDLE_ONBOARDING";
export const handleOnboarding = createAction(HANDLE_ONBOARDING);

export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const updateUserProfile = createAction(UPDATE_USER_PROFILE);

export const UPDATE_USER_PROFILE_FAILURE = "UPDATE_USER_PROFILE_FAILURE";
export const updateUserProfileFailure = createAction(UPDATE_USER_PROFILE_FAILURE);

export const UPDATE_USER_PROFILE_REQUESTED = "UPDATE_USER_PROFILE_REQUESTED";
export const updateUserProfileRequested = createAction(UPDATE_USER_PROFILE_REQUESTED);

export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const updateUserProfileSuccess = createAction(UPDATE_USER_PROFILE_SUCCESS);

export const UPDATE_USER_ONBOARDING_DETAILS = "UPDATE_USER_ONBOARDING_DETAILS";
export const updateUserOnBoardingDetails = createAction(UPDATE_USER_ONBOARDING_DETAILS);

export const FETCH_USERS_BY_ROLE = "FETCH_USERS_BY_ROLE";
export const fetchUsersByRole = createAction(FETCH_USERS_BY_ROLE);

export const FETCH_USERS_BY_ROLE_FAILURE = "FETCH_USERS_BY_ROLE_FAILURE";
export const fetchUsersByRoleFailure = createAction(FETCH_USERS_BY_ROLE_FAILURE);

export const FETCH_USERS_BY_ROLE_REQUESTED = "FETCH_USERS_BY_ROLE_REQUESTED";
export const fetchUsersByRoleRequested = createAction(FETCH_USERS_BY_ROLE_REQUESTED);

export const FETCH_USERS_BY_ROLE_SUCCESS = "FETCH_USERS_BY_ROLE_SUCCESS";
export const fetchUsersByRoleSuccess = createAction(FETCH_USERS_BY_ROLE_SUCCESS);

export const INVITE_USER_ON_PLATFORM = "INVITE_USER_ON_PLATFORM";
export const inviteUserOnPlatform = createAction(INVITE_USER_ON_PLATFORM);

export const INVITE_USER_ON_PLATFORM_FAILURE = "INVITE_USER_ON_PLATFORM_FAILURE";
export const inviteUserOnPlatformFailure = createAction(INVITE_USER_ON_PLATFORM_FAILURE);

export const INVITE_USER_ON_PLATFORM_REQUESTED = "INVITE_USER_ON_PLATFORM_REQUESTED";
export const inviteUserOnPlatformRequested = createAction(INVITE_USER_ON_PLATFORM_REQUESTED);

export const INVITE_USER_ON_PLATFORM_SUCCESS = "INVITE_USER_ON_PLATFORM_SUCCESS";
export const inviteUserOnPlatformSuccess = createAction(INVITE_USER_ON_PLATFORM_SUCCESS);

export const SEARCH_USER_BY_KEYWORD = "SEARCH_USER_BY_KEYWORD";
export const searchUserByKeyword = createAction(SEARCH_USER_BY_KEYWORD);

export const SEARCH_USER_BY_KEYWORD_FAILURE = "SEARCH_USER_BY_KEYWORD_FAILURE";
export const searchUserByKeywordFailure = createAction(SEARCH_USER_BY_KEYWORD_FAILURE);

export const SEARCH_USER_BY_KEYWORD_REQUESTED = "SEARCH_USER_BY_KEYWORD_REQUESTED";
export const searchUserByKeywordRequested = createAction(SEARCH_USER_BY_KEYWORD_REQUESTED);

export const SEARCH_USER_BY_KEYWORD_SUCCESS = "SEARCH_USER_BY_KEYWORD_SUCCESS";
export const searchUserByKeywordSuccess = createAction(SEARCH_USER_BY_KEYWORD_SUCCESS);

export const CHECK_USER_EXISTS = "CHECK_USER_EXISTS";
export const checkUserExists = createAction(CHECK_USER_EXISTS);

export const CHECK_USER_EXISTS_SUCCESS = "CHECK_USER_EXISTS_SUCCESS";
export const checkUserExistsSuccess = createAction("CHECK_USER_EXISTS_SUCCESS");

export const CHECK_USER_EXISTS_FAILURE = "CHECK_USER_EXISTS_FAILURE";
export const checkUserExistsFailure = createAction("CHECK_USER_EXISTS_FAILURE");

export const CHECK_USER_EXISTS_CLEAR = "CHECK_USER_EXISTS_CLEAR";
export const checkUserExistsClear = createAction(CHECK_USER_EXISTS_CLEAR);

export const CHECK_USER_EXISTS_CLEAR_SUCCESS = "CHECK_USER_EXISTS_CLEAR_SUCCESS";
export const checkUserExistsClearSuccess = createAction("CHECK_USER_EXISTS_CLEAR_SUCCESS");

export const UPDATE_USER_PASSWORD = "UPDATE_USER_PASSWORD";
export const updateUserPassword = createAction(UPDATE_USER_PASSWORD);

export const UPDATE_USER_PASSWORD_REQUESTED = "UPDATE_USER_PASSWORD_REQUESTED";
export const updateUserPasswordRequested = createAction(UPDATE_USER_PASSWORD_REQUESTED);

export const UPDATE_USER_PASSWORD_FAILURE = "UPDATE_USER_PASSWORD_FAILURE";
export const updateUserPasswordFailure = createAction(UPDATE_USER_PASSWORD_FAILURE);

export const UPDATE_USER_PASSWORD_SUCCESS = "UPDATE_USER_PASSWORD_SUCCESS";
export const updateUserPasswordSuccess = createAction(UPDATE_USER_PASSWORD_SUCCESS);

export const REQUEST_USER = "REQUEST_USER";
export const requestUser = createAction(REQUEST_USER);

export const REQUEST_USER_REQUESTED = "REQUEST_USER_REQUESTED";
export const requestUserRequested = createAction(REQUEST_USER_REQUESTED);

export const REQUEST_USER_FAILURE = "REQUEST_USER_FAILURE";
export const requestUserFailure = createAction(REQUEST_USER_FAILURE);

export const REQUEST_USER_SUCCESS = "REQUEST_USER_SUCCESS";
export const requestUserSuccess = createAction(REQUEST_USER_SUCCESS);
